// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import 'babel-polyfill'

import Vue from 'vue'
import { store } from './store'
import axios from 'axios'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import './assets/scss/app.scss'

import VueYoutube from 'vue-youtube'

import Utile from '@/utile/utile'

import App from './App'
import router from './router'

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$utile = Utile

Vue.use(Vuetify, {
  iconfont: 'md', // 'md' || 'mdi' || 'fa' || 'fa4'
  theme: {
    primary: '#0056e6',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#ff4444',
    info: '#33b5e5',
    success: '#00C851',
    warning: '#ffbb33',
    // 추가옵션
    title_color: '#005FFF',
    title_dark1: '#0056e6',
    title_dark2: '#004ecf'
  }
})

Vue.use(VueYoutube)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js